import PropTypes from 'prop-types';
export var animationPropTypes = {
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Animation/propTypes.js
// module id = 153
// module chunks = 0